/*
 * @Description:
 * @Author: Mayer
 * @Date: 2020-03-09 16:30:27
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
//import { BrowserRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";
import { store } from "../tools/store";

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
// 用户协议，隐私政策适配web浏览器系统语言
const hrefStr = window.location.href
if (hrefStr.indexOf('/privacyPolicy/') !== -1 || hrefStr.indexOf('/userAgreement/') !== -1 ) {
  const baseStr = hrefStr.slice(0,-2)
  const endStr = hrefStr.slice(-2)
  const lang = navigator.language.substring(0,2)
  const arr = ['en', 'az', 'et', 'pt', 'bg', 'is', 'pl', 'da', 'de', 'ru', 'fr', 'ar', 'fi', 'nl', 'cs', 
  'hr', 'lv', 'lt', 'lb', 'ro', 'nb','es', 'sv', 'sk', 'sl', 'uz', 'el', 'hu', 'it', 'hi', 'in']

  // const targetLang = arr.includes(lang) ? lang : endStr;
  // window.location.href = baseStr + targetLang;

  if(arr.includes(endStr)) {
    if(arr.includes(lang)) {
      window.location.href = baseStr + lang
    }else {
      window.location.href = baseStr + endStr 
    }
  } else { 
    if(arr.includes(lang)) {
      window.location.href = baseStr + lang
    }else {
      window.location.href = baseStr + 'en' 
    }
  }

  // if(arr.includes(endStr) && lang !== endStr) { 
  //   window.location.href = baseStr + lang
  // } else {
  //   window.location.href = baseStr + 'en'
  // }
}

// 问卷调查
const Questionnaire = Loadable({
  loader: () => import("../views/questionnaire/index1"),
  loading: MyLoadingComponent
});
const Information = Loadable({
  loader: () => import("../views/questionnaire/information"),
  loading: MyLoadingComponent,
});
// 问卷调研引导用户注册账号
const Guidance = Loadable({
  loader: () => import("../views/guidance/index"),
  loading: MyLoadingComponent
});
// 问卷调研引导用户注册账号中奖详情页
const Lottery = Loadable({
  loader: () => import("../views/guidance/lottery"),
  loading: MyLoadingComponent
});
// 问卷调研引导用户注册账号引导登录
const GuidanceMain = Loadable({
  loader: () => import("../views/guidance/main"),
  loading: MyLoadingComponent
});
// 第三方商户入驻申请111(伟耿需求)
const ApplicationRecord = Loadable({
  loader: () => import("../views/application-record"),
  loading: MyLoadingComponent
});
// 第三方商户入驻申请222(唐慧钰需求)
const MerchantSettled = Loadable({
  loader: () => import("../views/merchant-settled/index1"),
  loading: MyLoadingComponent
});
// 第三方商户入驻申请333(龚艳玲需求)
const MerchantEmployee = Loadable({
  loader: () => import("../views/merchant-employee"),
  loading: MyLoadingComponent
});

const MerchantSubmit = Loadable({
  loader: () => import("../views/merchant-settled/merchant-submit"),
  loading: MyLoadingComponent
});
// 摇一摇
const Landing = Loadable({
  loader: () => import("../views/shake/landing"),
  loading: MyLoadingComponent,
});
const Record = Loadable({
  loader: () => import("./shake/record"),
  loading: MyLoadingComponent,
});
const Rules = Loadable({
  loader: () => import("./shake/rules"),
  loading: MyLoadingComponent,
});
// 邀请人
const Invite = Loadable({
  loader: () => import("../views/invite/landing"),
  loading: MyLoadingComponent
});
const InviteSuccess = Loadable({
  loader: () => import("../views/invite/success"),
  loading: MyLoadingComponent
});

// ==============巴基斯坦服务卡在线支付与激活模块=================
// 问卷调研引导用户注册账号引导登录
// const CheckMain = Loadable({
//   loader: () => import("../views/b-extend/main"),
//   loading: MyLoadingComponent
// });
const CheckIMEI = Loadable({
  loader: () => import("../views/b-extend/index"),
  loading: MyLoadingComponent
});
const PayInfo = Loadable({
  loader: () => import("../views/b-extend/pay-info"),
  loading: MyLoadingComponent
});
const Agreement = Loadable({
  loader: () => import("../views/b-extend/agreement"),
  loading: MyLoadingComponent
});
const PayResult = Loadable({
  loader: () => import("../views/b-extend/pay-info/pay-res"),
  loading: MyLoadingComponent
});
const orderRes = Loadable({
  loader: () => import("../views/b-extend/result"),
  loading: MyLoadingComponent
});
// 定位获取经纬度
const Location = Loadable({
  loader: () => import("../views/location"),
  loading: MyLoadingComponent
});
// ============== 多语言用户协议与隐私政策=================
// 用户协议 
const userEn = Loadable({
  loader: () => import("../views/agreement/userAgreement/en"),
  loading: MyLoadingComponent
});
const userAr = Loadable({
  loader: () => import("../views/agreement/userAgreement/ar"),
  loading: MyLoadingComponent
});
const userFr = Loadable({
  loader: () => import("../views/agreement/userAgreement/fr"),
  loading: MyLoadingComponent
});
const userHi = Loadable({
  loader: () => import("../views/agreement/userAgreement/hi"),
  loading: MyLoadingComponent
});
const userRu = Loadable({
  loader: () => import("../views/agreement/userAgreement/ru"),
  loading: MyLoadingComponent
});
const userBrazilian = Loadable({
  loader: () => import("../views/agreement/userAgreement/pt"),
  loading: MyLoadingComponent
});
const userBulgarian = Loadable({
  loader: () => import("../views/agreement/userAgreement/bg"),
  loading: MyLoadingComponent
});
const userPolish = Loadable({
  loader: () => import("../views/agreement/userAgreement/pl"),
  loading: MyLoadingComponent
});
const userGerman = Loadable({
  loader: () => import("../views/agreement/userAgreement/de"),
  loading: MyLoadingComponent
});
const userDutch = Loadable({
  loader: () => import("../views/agreement/userAgreement/nl"),
  loading: MyLoadingComponent
});
const userCzech = Loadable({
  loader: () => import("../views/agreement/userAgreement/cs"),
  loading: MyLoadingComponent
});
const userRomanian = Loadable({
  loader: () => import("../views/agreement/userAgreement/ro"),
  loading: MyLoadingComponent
});
const userSwedish = Loadable({
  loader: () => import("../views/agreement/userAgreement/sv"),
  loading: MyLoadingComponent
});
const userSlovak = Loadable({
  loader: () => import("../views/agreement/userAgreement/sk"),
  loading: MyLoadingComponent
});
const userSloven = Loadable({
  loader: () => import("../views/agreement/userAgreement/sl"),
  loading: MyLoadingComponent
});
const userSpanish = Loadable({
  loader: () => import("../views/agreement/userAgreement/es"),
  loading: MyLoadingComponent
});
const userGreek = Loadable({
  loader: () => import("../views/agreement/userAgreement/el"),
  loading: MyLoadingComponent
});
const userHungarian = Loadable({
  loader: () => import("../views/agreement/userAgreement/hu"),
  loading: MyLoadingComponent
});
const userItalian = Loadable({
  loader: () => import("../views/agreement/userAgreement/it"),
  loading: MyLoadingComponent
});
const userEstonia = Loadable({
  loader: () => import("../views/agreement/userAgreement/et"),
  loading: MyLoadingComponent
});
const userLatvian = Loadable({
  loader: () => import("../views/agreement/userAgreement/lv"),
  loading: MyLoadingComponent
});
const userLithuanian = Loadable({
  loader: () => import("../views/agreement/userAgreement/lt"),
  loading: MyLoadingComponent
});
const userCroatian = Loadable({
  loader: () => import("../views/agreement/userAgreement/hr"),
  loading: MyLoadingComponent
});
const userDanish = Loadable({
  loader: () => import("../views/agreement/userAgreement/da"),
  loading: MyLoadingComponent
});
const userNorwegian = Loadable({
  loader: () => import("../views/agreement/userAgreement/nb"),
  loading: MyLoadingComponent
});
const userFinnish = Loadable({
  loader: () => import("../views/agreement/userAgreement/fi"),
  loading: MyLoadingComponent
});
const userIcelandic = Loadable({
  loader: () => import("../views/agreement/userAgreement/is"),
  loading: MyLoadingComponent
});
const userLuxembourgish = Loadable({
  loader: () => import("../views/agreement/userAgreement/lb"),
  loading: MyLoadingComponent
});
const userAzerbaijani = Loadable({
  loader: () => import("../views/agreement/userAgreement/az"),
  loading: MyLoadingComponent
});
const userUzbek = Loadable({
  loader: () => import("../views/agreement/userAgreement/uz"),
  loading: MyLoadingComponent
});
const userIndonesian = Loadable({
  loader: () => import("../views/agreement/userAgreement/in"),
  loading: MyLoadingComponent
});

// 隐私政策
const privacyEn = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/en"),
  loading: MyLoadingComponent
});
const privacyAr = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/ar"),
  loading: MyLoadingComponent
});
const privacyFr = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/fr"),
  loading: MyLoadingComponent
});
const privacyHi = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/hi"),
  loading: MyLoadingComponent
});
const privacyRu = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/ru"),
  loading: MyLoadingComponent
});
const privacyBrazilian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/pt"),
  loading: MyLoadingComponent
});
const privacyBulgarian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/bg"),
  loading: MyLoadingComponent
});
const privacyPolish = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/pl"),
  loading: MyLoadingComponent
});
const privacyGerman = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/de"),
  loading: MyLoadingComponent
});
const privacyDutch = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/nl"),
  loading: MyLoadingComponent
});
const privacyCzech = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/cs"),
  loading: MyLoadingComponent
});
const privacyRomanian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/ro"),
  loading: MyLoadingComponent
});
const privacySwedish = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/sv"),
  loading: MyLoadingComponent
});
const privacySlovak = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/sk"),
  loading: MyLoadingComponent
});
const privacySloven = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/sl"),
  loading: MyLoadingComponent
});
const privacySpanish = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/es"),
  loading: MyLoadingComponent
});
const privacyGreek = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/el"),
  loading: MyLoadingComponent
});
const privacyHungarian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/hu"),
  loading: MyLoadingComponent
});
const privacyItalian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/it"),
  loading: MyLoadingComponent
});
const privacyEstonia = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/et"),
  loading: MyLoadingComponent
});
const privacyLatvian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/lv"),
  loading: MyLoadingComponent
});
const privacyLithuanian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/lt"),
  loading: MyLoadingComponent
});
const privacyCroatian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/hr"),
  loading: MyLoadingComponent
});
const privacyDanish = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/da"),
  loading: MyLoadingComponent
});
const privacyNorwegian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/nb"),
  loading: MyLoadingComponent
});
const privacyFinnish = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/fi"),
  loading: MyLoadingComponent
});
const privacyIcelandic = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/is"),
  loading: MyLoadingComponent
});
const privacyLuxembourgish = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/lb"),
  loading: MyLoadingComponent
});
const privacyAzerbaijani = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/az"),
  loading: MyLoadingComponent
});
const privacyUzbek = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/uz"),
  loading: MyLoadingComponent
});
const privacyIndonesian = Loadable({
  loader: () => import("../views/agreement/privacyPolicy/in"),
  loading: MyLoadingComponent
});
// 报错页
const Error = Loadable({
  loader: () => import("../views/error"),
  loading: MyLoadingComponent
});
const routes = [
  {
    path: "/questionnaire", // 问券调查信息填写页面
    component: Questionnaire
  },
  {
    path: "/information", // 问券调查信息展示页
    component: Information
  },
  {
    path: "/application-record", // 第三方商户入驻申请111(伟耿需求)
    component: ApplicationRecord
  },
  {
    path: "/merchant-settled", // 第三方商户入驻申请222(唐慧钰需求)
    component: MerchantSettled,
    title: "Carlcare Online Partner Wanted"
  },
  {
    path: "/merchant-submit", // 第三方商户入驻申请提交页222(唐慧钰需求)
    component: MerchantSubmit,
    title: "Carlcare Online Partner Wanted"
  },
  {
    path: "/merchant-employee", // 第三方商户入驻申请333(龚艳玲需求)
    component: MerchantEmployee,
    title: "Carlcare Online Partner Wanted"
  },
  {
    path: "/merchant-submit", // 第三方商户入驻申请提交页333(龚艳玲需求)
    component: MerchantSubmit,
    title: "Carlcare Online Partner Wanted"
  },
  {
    path: "/guidance", // 问卷调研引导用户注册账号
    component: Guidance
  },
  {
    path: "/lottery", // 问卷调研引导用户注册账号
    component: Lottery
  },
  {
    path: "/guidancemain", // 问卷调研引导用户注册账号
    component: GuidanceMain
  },
  {
    path: "/landing", // 摇一摇首页
    component: Landing,
  },
  {
    path: "/record", // 摇一摇获奖记录页
    component: Record,
  },
  {
    path: "/rules", // 摇一摇规则
    component: Rules,
  },
  {
    path: "/invite", // 邀请人
    component: Invite,
  },
  {
    path: "/invitesuccess", // 邀请成功
    component: InviteSuccess,
  },
  // ==============巴基斯坦服务卡在线支付与激活模块=================
  // {
  //   path: "/checkmain", // 问卷调研引导用户注册账号
  //   component: CheckMain
  // },
  {
    path: "/check", // 校验提交信息
    component: CheckIMEI,
  },
  {
    path: "/pay", // 下单页
    component: PayInfo,
  },
  {
    path: "/agreement", // 服务协议
    component: Agreement,
  },
  {
    path: "/pay-result", // 支付结果页
    component: PayResult,
  },
  {
    path: "/result", // 激活信息页
    component: orderRes,
  },
  {
    path: "/location", // 定位获取经纬度
    component: Location,
  },
  // ============== 多语言用户协议与隐私政策 =================
  // 用户协议       
  {
    path: "/userAgreement/en", // 英语
    component: userEn,
  },
  {
    path: "/userAgreement/fr", // 法语
    component: userFr,
  },
  {
    path: "/userAgreement/ar", // 阿拉伯语
    component: userAr,
  },
  {
    path: "/userAgreement/ru", // 俄语
    component: userRu,
  },
  {
    path: "/userAgreement/hi", // 印地语
    component: userHi,
  },
  {
    path: "/userAgreement/pt", // 巴西葡语
    component: userBrazilian,
  },
  {
    path: "/userAgreement/bg", // 保加利亚语
    component: userBulgarian,
  },
  {
    path: "/userAgreement/pl", // 波兰语
    component: userPolish,
  },
  {
    path: "/userAgreement/de", // 德语
    component: userGerman,
  },
  {
    path: "/userAgreement/nl", // 荷兰语
    component: userDutch,
  },
  {
    path: "/userAgreement/cs", // 捷克语
    component: userCzech,
  },
  {
    path: "/userAgreement/ro", // 罗马尼亚语
    component: userRomanian,
  },
  {
    path: "/userAgreement/sv", // 瑞典语
    component: userSwedish,
  },
  {
    path: "/userAgreement/sk", // 斯洛伐克语
    component: userSlovak,
  },
  {
    path: "/userAgreement/sl", // 斯洛文尼亚语
    component: userSloven,
  },
  {
    path: "/userAgreement/es", // 西班牙语
    component: userSpanish,
  },
  {
    path: "/userAgreement/el", // 希腊语
    component: userGreek,
  },
  {
    path: "/userAgreement/hu", // 匈牙利语
    component: userHungarian,
  },
  {
    path: "/userAgreement/it", // 意大利语
    component: userItalian,
  },
  {
    path: "/userAgreement/et", // 爱沙尼亚语
    component: userEstonia,
  },
  {
    path: "/userAgreement/lv", // 拉脱维亚语
    component: userLatvian,
  },
  {
    path: "/userAgreement/lt", // 立陶宛语
    component: userLithuanian,
  },
  {
    path: "/userAgreement/hr", // 克罗地亚语
    component: userCroatian,
  },
  {
    path: "/userAgreement/da", // 丹麦语
    component: userDanish,
  },
  {
    path: "/userAgreement/nb", // 挪威语
    component: userNorwegian,
  },
  {
    path: "/userAgreement/fi", // 芬兰语
    component: userFinnish,
  },
  {
    path: "/userAgreement/is", // 冰岛语
    component: userIcelandic,
  },
  {
    path: "/userAgreement/lb", // 卢森堡语
    component: userLuxembourgish,
  },
  {
    path: "/userAgreement/az", // 阿塞拜疆语
    component: userAzerbaijani,
  },
  {
    path: "/userAgreement/uz", // 乌兹别克斯坦语
    component: userUzbek,
  },
  {
    path: "/userAgreement/in", // 印尼语
    component: userIndonesian,
  },
  // 隐私政策           
  {
    path: "/privacyPolicy/en", // 英语
    component: privacyEn,
  },
  {
    path: "/privacyPolicy/fr", // 法语
    component: privacyFr,
  },
  {
    path: "/privacyPolicy/ar", // 阿拉伯语
    component: privacyAr,
  },
  {
    path: "/privacyPolicy/ru", // 俄语
    component: privacyRu,
  },
  {
    path: "/privacyPolicy/hi", // 印地语
    component: privacyHi,
  },
  {
    path: "/privacyPolicy/pt", // 巴西葡语
    component: privacyBrazilian,
  },
  {
    path: "/privacyPolicy/bg", // 保加利亚语
    component: privacyBulgarian,
  },
  {
    path: "/privacyPolicy/pl", // 波兰语
    component: privacyPolish,
  },
  {
    path: "/privacyPolicy/de", // 德语
    component: privacyGerman,
  },
  {
    path: "/privacyPolicy/nl", // 荷兰语
    component: privacyDutch,
  },
  {
    path: "/privacyPolicy/cs", // 捷克语
    component: privacyCzech,
  },
  {
    path: "/privacyPolicy/ro", // 罗马尼亚语
    component: privacyRomanian,
  },
  {
    path: "/privacyPolicy/sv", // 瑞典语
    component: privacySwedish,
  },
  {
    path: "/privacyPolicy/sk", // 斯洛伐克语
    component: privacySlovak,
  },
  {
    path: "/privacyPolicy/sl", // 斯洛文尼亚语
    component: privacySloven,
  },
  {
    path: "/privacyPolicy/es", // 西班牙语
    component: privacySpanish,
  },
  {
    path: "/privacyPolicy/el", // 希腊语
    component: privacyGreek,
  },
  {
    path: "/privacyPolicy/hu", // 匈牙利语
    component: privacyHungarian,
  },
  {
    path: "/privacyPolicy/it", // 意大利语
    component: privacyItalian,
  },
  {
    path: "/privacyPolicy/et", // 爱沙尼亚语
    component: privacyEstonia,
  },
  {
    path: "/privacyPolicy/lv", // 拉脱维亚语
    component: privacyLatvian,
  },
  {
    path: "/privacyPolicy/lt", // 立陶宛语
    component: privacyLithuanian,
  },
  {
    path: "/privacyPolicy/hr", // 克罗地亚语
    component: privacyCroatian,
  },
  {
    path: "/privacyPolicy/da", // 丹麦语
    component: privacyDanish,
  },
  {
    path: "/privacyPolicy/nb", // 挪威语
    component: privacyNorwegian,
  },
  {
    path: "/privacyPolicy/fi", // 芬兰语
    component: privacyFinnish,
  },
  {
    path: "/privacyPolicy/is", // 冰岛语
    component: privacyIcelandic,
  },
  {
    path: "/privacyPolicy/lb", // 卢森堡语
    component: privacyLuxembourgish,
  },
  {
    path: "/privacyPolicy/az", // 阿塞拜疆语
    component: privacyAzerbaijani,
  },
  {
    path: "/privacyPolicy/uz", // 乌兹别克斯坦语
    component: privacyUzbek,
  },
  {
    path: "/privacyPolicy/in", // 印尼语
    component: privacyIndonesian,
  },
  {
    path: "/error", // 报错页
    component: Error
  }
];


const mRoute = () => {
  return (
    <Provider store={store}>
      <Router>{renderRoutes(routes)}</Router>
    </Provider>
  );
};

export default mRoute;
